/** A single title within a company, with what Adi did in it. Continuous roles
 *  at one company are grouped and shown stepped, most recent first, like
 *  LinkedIn. */
export type Position = { title: string; period: string; summary: string };

export type Role = {
  company: string;
  /** Overall span across the grouped positions. */
  period: string;
  positions: Position[];
  stack: string[];
};

/** Real roles, no embellishment — kept current with Adi's LinkedIn. */
export const experience: Role[] = [
  {
    company: "Atlassian",
    period: "Feb 2024 — Present",
    positions: [
      {
        title: "Senior Software Engineer",
        period: "Aug 2026 — Present",
        summary:
          "Working on frontier Confluence AI experiences, with a focus on diagramming.",
      },
      {
        title: "Software Engineer",
        period: "Feb 2025 — Aug 2026",
        summary:
          "Lead engineer and DRI for Confluence Slides, a new AI-powered content experience built on the Canvas and Whiteboards foundations. Took it from prototype to customer rollout across product architecture, AI creation and editing, reliability and launch.",
      },
      {
        title: "Graduate Software Engineer",
        period: "Feb 2024 — Feb 2025",
        summary:
          "Engineer on Confluence Whiteboards. Built canvas features like board export, layout assistance and early AI-assisted whiteboarding, and improved Miro, Mural and PDF import quality through parser architecture, visual fidelity and reliability.",
      },
    ],
    stack: ["React", "TypeScript", "Canvas", "AWS"],
  },
  {
    company: "Sadafal Education",
    period: "Apr 2020 — Present",
    positions: [
      {
        title: "Full Stack Developer, UI Designer",
        period: "Apr 2020 — Present",
        summary:
          "Full redesign and implementation of the global website. Leading development of a global education platform and an e-commerce site for student-made products.",
      },
    ],
    stack: ["React", "TypeScript", "Remix", "GraphQL", "CosmosDB"],
  },
  {
    company: "Atlassian",
    period: "Nov 2022 — Jun 2023",
    positions: [
      {
        title: "Full Stack Developer Intern",
        period: "Nov 2022 — Jun 2023",
        summary:
          "Full-stack developer in the Rollout and Experimentation team on the Decisions Platform. Engaged in the complete software development lifecycle with mentorship from Senior to Principal Engineers.",
      },
    ],
    stack: ["React", "TypeScript", "GraphQL", "PostgreSQL"],
  },
  {
    company: "Accenture & Autism Awareness",
    period: "Jan 2021 — Feb 2022",
    positions: [
      {
        title: "Full Stack Developer",
        period: "Jan 2021 — Feb 2022",
        summary:
          "Building an intelligent education platform for children with ASD. Focused on tailored content with detailed analysis and guidance for parents.",
      },
    ],
    stack: ["React", "TypeScript", "Apollo GraphQL", "MongoDB"],
  },
  {
    company: "Optus",
    period: "Mar 2021 — Aug 2021",
    positions: [
      {
        title: "Full Stack Developer Intern",
        period: "Mar 2021 — Aug 2021",
        summary:
          "Worked on Digital Networks Automation, creating and optimising automation tools for the Network team. Introduced DevOps practices and learned from Senior Network Engineers.",
      },
    ],
    stack: ["React", "TypeScript", "MongoDB", "Docker", "Rancher"],
  },
];

export type SkillGroup = { label: string; items: string[] };

/** Verbatim from Adi's own site. */
export const skills: SkillGroup[] = [
  {
    label: "Frontend",
    items: ["React", "TypeScript", "Next.js", "HTML", "CSS", "Emotion"],
  },
  {
    label: "Backend",
    items: ["Node.js", "Python", "FastAPI", "Django", "GraphQL", "Express"],
  },
  {
    label: "DevOps",
    items: ["Docker", "AWS", "Rancher", "Harbor", "GitHub Actions", "Helm"],
  },
  {
    label: "Databases",
    items: ["PostgreSQL", "MongoDB", "DynamoDB", "SQLite", "CosmosDB"],
  },
];

export const social = {
  email: "kishek12@gmail.com",
  github: "https://github.com/kishek2000",
  linkedin: "https://www.linkedin.com/in/adi-kishore/",
  soundcloud: "https://soundcloud.com/adi-kishore/",
};
